import * as React from 'react';
import { useDispatch } from 'react-redux';

import { setRateOurUserPrice } from '../../../actions/rateOurEstimation';

export function useSetUserPrice() {
  const dispatch = useDispatch();

  return React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      const clearValue = value.replace(/\s/g, '');

      if (/[^\d]/g.test(clearValue)) {
        return;
      }

      dispatch(setRateOurUserPrice(Number(clearValue)));
    },
    [dispatch],
  );
}
